import React, { ChangeEventHandler } from 'react';

interface RadioButtonProps {
  label: string;
  value: string;
}

interface RadioButtonListProps {
  options: Array<RadioButtonProps>;
  name: string;
  onChange: ChangeEventHandler<HTMLElement>;
  defaultValue: string;
}

const RadioButtonList: React.FC<RadioButtonListProps> = ({
  options, name, defaultValue, onChange,
}) => (
  <div className="form-group">
    {
      options.map((option) => (
        <div className="inline" key={option.value}>
          <input
            type="radio"
            value={option.value}
            name={name}
            id={`${name}_${option.value}`}
            onChange={onChange}
            checked={defaultValue === option.value}
          />

          <label htmlFor={`${name}_${option.value}`}>{option.label}</label>
        </div>
      ))
    }

  </div>
);

export default RadioButtonList;
